<template>
	<div id="detail">
        <img :src="$store.state.sassConfig.imglogo_dark" alt="" class="appLogo">
        <div class="btns">
			<a :href="iosUrl" class="link">iOS版本下载</a>
			<a :href="androidUrl"  class="link">Android版本下载</a>
		</div>
	</div>
</template>

<script>
	export default {
        data(){
            return {
                iosUrl:'',
                androidUrl:''
            }
        },
        created(){
            //中绩
            if(this.$store.state.sassConfig.id == '223456789'){
                this.iosUrl = 'https://apps.apple.com/us/app/%E4%B8%AD%E7%BB%A9%E7%BD%91%E6%A0%A1/id6453687579'
                this.androidUrl = 'https://sj.qq.com/appdetail/com.zhongjiwangxiao.androidapp?landing_type=yybclient'
            }else if(this.$store.state.sassConfig.id == '123456789'){
                //中佳
            }
        }


    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
	#detail {
		position: relative;
        width: 100%;
        height: 100vh;
        background: url(../../assets/app_bg.png)no-repeat center center #6ca7f9;
        background-size: 100%;
        .appLogo{
            position: relative;
            top: 10%;
            margin: 0 auto;
            width: 38%;
            padding: 5px 10px;
            display: block;
            border-radius: 6px;
            background-color: rgba(255, 255, 255,.6);
        }
        .btns{
            width: 60%;
            position: absolute;
            left: 20%;
            bottom: 2%;


            .link{
                width: 100%;
                height: 46px;
                line-height: 46px;
                background: #fff;
                border-radius: 3px;
                color: #6ca7f9;
                font-size: 16px;
                text-align: center;
                text-decoration: none;
                margin: 0 auto 26px;
                display: block;
            }


        }

	}

</style>
